import React, { useEffect } from 'react';
import { Row, Col } from "reactstrap";
import { Apify } from "../../../Apify";
import store from '../../../store';
import { T, TraksConsumer } from '../../../traks';

const UpgradeGameSelectByUserId = (props) => {
    const select_box_no_selected_text = props.is_logged_in
        ? props.render_static(<T>No game selected</T>)
        : props.render_static(<T>Login to see your games</T>)

        const gameChanged = (e) => {
            const selectedValue = parseInt(e.target.value, 10);
            props.setGame(selectedValue);
            localStorage.setItem('cart-game', selectedValue ? selectedValue : 0);

            let minKeys = 1;
            let minMonths = 1;
            if (selectedValue !== 0 && props.response) {
              const game = props.response.find((g) => g.GameId === selectedValue);
              if (game) {
                const portfolioCount = props.subscription === 'pro' ? game.PortFoliosCount - 1 : game.PortFoliosCount;
                minKeys = portfolioCount - game.RemainingProInvites;
                minMonths = game.RemainingMonths;
                props.setGameTitle(game.GameName);
                store.dispatch_value("show_cart_game_upgrade", {
                  game_id: game.GameId,
                  completed: false
                });
              }
            } else {
                props.setGameTitle(null);
                store.dispatch_value("show_cart_game_upgrade", {
                  game_id: 0,
                  completed: false
                });
            }
            
            props.setMinimumOfKeys(Math.max(1, minKeys));
            props.setNumberOfKeys((prev) => (prev < minKeys ? Math.max(1, minKeys) : prev));

            props.setMinimumOfMonths(Math.max(1, minMonths));
            props.setNumberOfMonths(Math.max(1, minMonths));
        }

    useEffect(() => {
        if (props.game && props.response) {
            const event = { target: { value: props.game } };
            gameChanged(event);
        }
    }, [])

    return (
        <select className='form-control' onChange={gameChanged} value={props.game ? props.game : 0}>
            <option value={0} data-min-keys={1}>{select_box_no_selected_text}</option>
            {props.is_logged_in && props.response && props.response.length !== 0 && props.response.map((item) => {
                const keys_needed = item.PortFoliosCount - item.RemainingProInvites;

                return <option value={item.GameId} data-min-keys={keys_needed}>{item.GameName}</option>
            })}
        </select>
    )
}

const UpgradeGameSelectWrapperByUserId = Apify("/a/game_keys")
    .with_response_prop('response')
    .wrap(UpgradeGameSelectByUserId);

const UpgradeGameSelectHandler = (props) => {
    const state = store.getState();
    const is_logged_in = state.me ? true : false;

    const {containerClassName, imgSrc, label} = props;

    const element = is_logged_in ? <UpgradeGameSelectWrapperByUserId is_logged_in={true} subscription={state.me.Subscription} {...props} /> : <UpgradeGameSelectByUserId is_logged_in={false} />;

    return (
        <div className={`no-spinner number-input-container ${containerClassName}`}>
                <Row className="align-items-center">
                    <Col xs={6}>
                        {imgSrc && (<img className="checkout-icon" src={imgSrc} alt="icon" />)}
                        <label className="ad_120_bold pl-2 number-input-text">{label}</label>
                    </Col>
                    <Col xs={6} className="text-right">
                        <TraksConsumer>
                            {element}
                        </TraksConsumer>
                    </Col>
                </Row>
        </div>
    )
}

export { UpgradeGameSelectHandler }


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Order/UpgradeGameSelect.js